import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import {
  fetchConnectionPairs,
  selectConnectionPairs,
  selectConnectionPairsRecordLoaded,
} from "@/features/connections/integrationSlice";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConnectionType } from "@/utils/utils";
import { SearchIcon } from "@/ImageRepo";
import "./ConnectionPairGrid.css";
import { createAlert } from "@/features/homepage/alertSliceList";
import axios from "@/features/axiosHelper";
import ShepTable from "@/components/GenericComponents/ShepTable";

const ConnectionPairGrid = () => {
  const dispatch = useDispatch();
  const rows = useSelector(selectConnectionPairs);
  const recordsLoaded = useSelector(selectConnectionPairsRecordLoaded);
  const [searchFilter, setSearchFilter] = useState("");

  useEffect(() => {
    fetchRecords();
  }, []);

  const columns = [
    {
      field: "ConnectionPairId",
    },
    {
      field: "ConnectionPairName",
      headerName: "Connection Pair Name",
      width: 300,
    },
    {
      field: "ConnectionName1",
      headerName: "Connection A",
      width: 250,
    },
    {
      field: "Connection_1_Type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => {
        return ConnectionType[params?.value] ?? "-";
      },
    },
    {
      field: "Connection_1_EndpointName",
      headerName: "Endpoint",
      width: 250,
    },
    {
      field: "ConnectionName2",
      headerName: "Connection B",
      width: 250,
    },
    {
      field: "Connection_2_Type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => {
        return ConnectionType[params?.value] ?? "-";
      },
    },
    {
      field: "Connection_2_EndpointName",
      headerName: "Endpoint",
      width: 250,
    },
    /* This feature is hidden for the moment, as PdM thinks this operation
       is too risky to be on the manager page, even with the validation.
    {
      field: "delete",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <IconButton
          onClick={() => validateDelete(params)}
          className="workflow-row"
        >
          <div className="connection-pair-delete"></div>
        </IconButton>
      ),
    },
    */
  ];

  const handleTextChange = (event) => {
    setSearchFilter(event.target.value);
    if (event.target.value === "") {
      fetchRecords(""); // If the input value becomes empty, then refresh the grid
    }
  };

  const fetchRecords = (searchFilter) => {
    const params = {
      clearCache: true,
      searchFilter: searchFilter,
    };
    dispatch(fetchConnectionPairs(params));
  };

  const validateDelete = (e) => {
    dispatch(
      createAlert({
        status: "Warning",
        alertType: "result",
        title: "Delete Connection Pair",
        message: "Are you sure you want to delete this Connection Pair?",
        buttonLabel: "Delete",
        onButtonClick: () => handleDelete(e.row),
        buttonLabel2: "Cancel",
      })
    );
  };

  const handleDelete = (row) => {
    axios
      .delete(`/connectionpair/connection-pairs`, {
        params: {
          connectionPairId: row.ConnectionPairId,
        },
      })
      .then((response) => {
        if (response.data) {
          dispatch(
            createAlert({
              status: "Success",
              alertType: "single",
              title: "Successfully saved changes.",
              message: "The Connection Pair has been deleted.",
            })
          );
          fetchRecords();
        } else {
          dispatch(
            createAlert({
              status: "Error",
              alertType: "result",
              title: "Unable to save changes.",
              message: "Unable to delete Connection Pair",
              buttonLabel: "Close",
            })
          );
        }
      });
  };

  return (
    <>
      <Box sx={{ marginTop: "60px" }}>
        <Box>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "var(--text-icon-regular)" }} />
                </InputAdornment>
              ),
            }}
            placeholder={"Search by Connection Pair or Connection Name"}
            value={searchFilter}
            onChange={handleTextChange}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.defaultPrevented = true; // Prevent's default 'Enter' behavior.
                fetchRecords(searchFilter);
              }
            }}
            sx={{
              width: "450px",
              marginBottom: "10px",
              "&:hover fieldset": {
                backgroundColor: "#ffffff",
              },
              "&.MuiFormControl-root .MuiInputBase-root": {
                borderRadius: "5px",
              },
              "&:hover fieldset": {
                color: "#000000",
              },
            }}
          />

          <ShepTable
            tableTitle="Connection Pairs"
            isDataLoaded={recordsLoaded}
            dataRows={rows}
            columnTitles={columns}
            selectionDisabled={true}
            getRowId={(row) => row.ConnectionPairId}
            columnVisibilityModel={{
              ConnectionPairId: false,
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default ConnectionPairGrid;
